import ServerLeaderboardInterface from "../objects/ServerLeaderboardInterface";
import ServerStatusInterface from "../objects/ServerStatusInterface";
import EconomyDataInterface from "../objects/EconomyDataInterface";
import PlayerProfileInterface from "../objects/PlayerProfileInterface";
import ServerStatisticsInterface from "../objects/ServerStatisticsInterface";
import DeadByDaylight from "../objects/DeadByDaylightInterface";
import IDragonSlayerData from "../objects/IDragonSlayerData";
import IKarmaStats from '../objects/IKarmaStats';

export type McMMOAbility =
	'swords'
	| 'taming'
	| 'mining'
	| 'woodcutting'
	| 'repair'
	| 'unarmed'
	| 'herbalism'
	| 'excavation'
	| 'archery'
	| 'axes'
	| 'acrobatics'
	| 'fishing'
	| 'alchemy'
	| 'total';

export type ServerType =
	'global'
	| 'survival'
	| 'skyblock'
	| 'creative'
	| 'vanilla'
	| 'prison'
	| 'anarchy'
	| 'oneblock'
	| 'event-server'
	| 'lobby'
	| 'vanilla_116'
	| 'hardcore-vanilla'
	| 'skycloud';

const fetchTotalVotes = async (): Promise<EconomyDataInterface[]> => {
	return await fetch('https://api.craftmania.cz/economy/leaderboard/total-votes')
		.then((res: Response) => res.json())
		.then((result: any) => {
			return result.data;
		});
};

const fetchMonthlyVotes = async (): Promise<EconomyDataInterface[]> => {
	return await fetch('https://api.craftmania.cz/economy/leaderboard/month-votes')
		.then((res: Response) => res.json())
		.then((result: any) => {
			return result.data;
		});
};

const fetchWeeklyVotes = async (): Promise<EconomyDataInterface[]> => {
	return await fetch('https://api.craftmania.cz/economy/leaderboard/week-votes')
		.then((res: Response) => res.json())
		.then((result: any) => {
			return result.data;
		});
};

/**
 * Metoda, která vrací levels leaderboard dle serveru {@link ServerLeaderboardInterface}
 * @param server Server type
 */
const fetchServerLevelLeaderboard = async (server: ServerType): Promise<ServerLeaderboardInterface> => {
	return await fetch(`https://api.craftmania.cz/economy/leaderboard/levels/${server}`)
		.then((res: Response) => res.json())
		.then((result: any) => {
			return result.data;
		});
};

const fetchServerStatus = async (): Promise<ServerStatusInterface> => {
	return await fetch('https://api.craftmania.cz/server/playercount')
		.then((res: Response) => res.json())
		.then((result: any) => {
			return result.data;
		});
};

const fetchServerStatistics = async (): Promise<ServerStatisticsInterface> => {
	return await fetch('https://api.craftmania.cz/server/statistics')
		.then((res: Response) => res.json())
		.then((result: any) => {
			return result.data;
		});
};

const fetchCraftCoinsLeaderboard = async (): Promise<EconomyDataInterface> => {
	return await fetch('https://api.craftmania.cz/economy/leaderboard/craft-coins')
		.then((res: Response) => res.json())
		.then((result: any) => {
			return result.data;
		});
};

const fetchReputationLeaderboard = async (): Promise<EconomyDataInterface> => {
	return await fetch('https://api.craftmania.cz/economy/leaderboard/karma-points')
		.then((res: Response) => res.json())
		.then((result: any) => {
			return result.data;
		});
};

const fetchCraftTokensLeaderboard = async (): Promise<EconomyDataInterface> => {
	return await fetch('https://api.craftmania.cz/economy/leaderboard/craft-tokens')
		.then((res: Response) => res.json())
		.then((result: any) => {
			return result.data;
		});
};

const fetchVoteTokensLeaderboard = async (): Promise<EconomyDataInterface> => {
	return await fetch('https://api.craftmania.cz/economy/leaderboard/vote-tokens')
		.then((res: Response) => res.json())
		.then((result: any) => {
			return result.data;
		});
};

const fetchQuestPointsLeaderboard = async (): Promise<EconomyDataInterface> => {
	return await fetch('https://api.craftmania.cz/economy/leaderboard/quest-points')
		.then((res: Response) => res.json())
		.then((result: any) => {
			return result.data;
		});
};

const fetchPlaytimeLeaderboard = async (): Promise<EconomyDataInterface[]> => {
	return await fetch('https://api.craftmania.cz/economy/leaderboard/played-time')
		.then((res: Response) => res.json())
		.then((result: any) => {
			return result.data;
		});
};

const fetchEventPointsLeaderboard = async (): Promise<EconomyDataInterface> => {
	return await fetch('https://api.craftmania.cz/economy/leaderboard/event-points')
		.then((res: Response) => res.json())
		.then((result: any) => {
			return result.data;
		});
};

const fetchSeasonPointsLeaderboard = async (): Promise<EconomyDataInterface> => {
	return await fetch('https://api.craftmania.cz/economy/leaderboard/season-points')
		.then((res: Response) => res.json())
		.then((result: any) => {
			return result.data;
		});
};

const fetchMcMMOLeaderboard = async (server: ServerType, abilityType: McMMOAbility): Promise<EconomyDataInterface> => {
	return await fetch(`https://api.craftmania.cz/economy/leaderboard/mcmmo/${server}/${abilityType}`)
		.then((res: Response) => res.json())
		.then((result: any) => {
			return result.data;
		});
};

const fetchGlobalLevelsLeaderboard = async (): Promise<EconomyDataInterface[]> => {
	return await fetch('https://api.craftmania.cz/economy/leaderboard/levels/global')
		.then((res: Response) => res.json())
		.then((result: any) => {
			return result.data;
		});
};

const fetchIslandTopLeaderboard = async (): Promise<EconomyDataInterface[]> => {
	return await fetch('https://api.craftmania.cz/economy/leaderboard/skyblock-islands')
		.then((res: Response) => res.json())
		.then((result: any) => {
			return result.data;
		});
};

const fetchPlayerProfile = async (name: string): Promise<PlayerProfileInterface> => {
	return await fetch('https://api.craftmania.cz/player/' + name)
		.then((res: Response) => res.json())
		.then((result: any) => {
			return result.data;
		});
};

const fetchPlayerProfileKarmaHistory = async (name: string): Promise<IKarmaStats[]> => {
	return await fetch('https://api.craftmania.cz/player/' + name + '/karma')
		.then((res: Response) => res.json())
		.then((result: any) => {
			return result.data;
		});
};

const fetchDeadByDaylightLeaderboard = async (): Promise<DeadByDaylight[]> => {
	return await fetch('https://api.craftmania.cz/economy/leaderboard/halloween')
		.then((res: Response) => res.json())
		.then((result: any) => {
			return result.data;
		});
};

const fetchDeadByDaylightProfile = async (nick: string): Promise<DeadByDaylight> => {
	return await fetch('https://api.craftmania.cz/player/' + nick + '/halloween')
		.then((res: Response) => res.json())
		.then((result: any) => {
			return result.data;
		});
};

const fetchPrisonRanksLeaderboard = async (): Promise<any> => {
	return await fetch('https://api.craftmania.cz/economy/leaderboard/prison-ranks')
		.then((res: Response) => res.json())
		.then((result: any) => {
			return result.data;
		});
};

const fetchDragonSlayerData = async (serverType: ServerType): Promise<IDragonSlayerData[]> => {
	return await fetch(`https://api.craftmania.cz/economy/leaderboard/dragon-slayer/${serverType}`)
		.then((res: Response) => res.json())
		.then((result: any) => {
			return result.data;
		});
};

const fetchServerBalanceLeaderboard = async (serverType: ServerType): Promise<EconomyDataInterface[]> => {
	return await fetch(`https://api.craftmania.cz/economy/leaderboard/balance/${serverType}`)
		.then((res: Response) => res.json())
		.then((result: any) => {
			return result.data;
		});
};

export {

	// Votes
	fetchTotalVotes,
	fetchMonthlyVotes,
	fetchWeeklyVotes,

	// Server leaderboards
	fetchServerLevelLeaderboard,
	fetchGlobalLevelsLeaderboard,

	// Server stats
	fetchServerStatus,
	fetchServerStatistics,

	// Economy
	fetchCraftCoinsLeaderboard,
	fetchCraftTokensLeaderboard,
	fetchVoteTokensLeaderboard,
	fetchQuestPointsLeaderboard,
	fetchPlaytimeLeaderboard,
	fetchEventPointsLeaderboard,
	fetchSeasonPointsLeaderboard,
	fetchMcMMOLeaderboard,
	fetchIslandTopLeaderboard,
	fetchPrisonRanksLeaderboard,
	fetchDragonSlayerData,
	fetchServerBalanceLeaderboard,
	fetchReputationLeaderboard,

	// Minigames
	fetchDeadByDaylightLeaderboard,
	fetchDeadByDaylightProfile,

	// Player
	fetchPlayerProfile,
	fetchPlayerProfileKarmaHistory
};
